<template>
  <v-dialog 
  v-model="dialog" 
  content-class="c-dialog-border-13"
  scrollable 
  persistent 
  transition="c-anim-slide-left-fade"
  :fullscreen="$vuetify.breakpoint.xs" 
  max-width="400px">

  <v-card>

    <v-layout align-center class="c-flex-00a crx-toolbar">
      <v-btn
      icon
      @click="dialog = false">
        <v-icon color="color1">mdi-close</v-icon>
      </v-btn>
      <div class="c-flex-r1 align-center justify-center subheading font-weight-bold">
        {{ id ? 'Edit' : 'New supplier' }}
      </div>
      <v-btn
      icon
      @click.native="confirm"
      :loading="loading">
        <v-icon color="color1">mdi-check</v-icon>
      </v-btn>
    </v-layout>
    
    <!-- DIALOG MAIN CONTENT -->
    <div style="overflow: auto;" class="pa-3">

      <div class="c-flex-c1">
      <img style="align-self: center;" src="@/assets/img/illustrations/open.png" alt="cardboard box" width="80px">

        <v-text-field 
        v-model.trim="name" 
        label="Name" 
        required
        counter="200"
        :error-messages="nameErrors"
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"></v-text-field>
        <v-text-field 
        v-model="email" 
        label="Email"
        counter="500"
        :error-messages="emailErrors"></v-text-field>
        <v-text-field 
        v-model="leadTime" 
        label="Lead time"
        hint="in days *"
        counter="500"
        :error-messages="leadTimeErrors"></v-text-field>

      </div>
    </div><!-- END DIALOG MAIN CONTENT -->
    </v-card>

  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  data () {
    return {
      dialog: false,
      id: null,
      name: '',
      email: '',
      leadTime: 0,
      error: '',
      loading: false
    }
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.maxLength && errors.push('Name must be less than 200 characters')
      !this.$v.name.required && errors.push('Name is required.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.maxLength && errors.push('Email must be less than 500 characters')
      return errors
    },
    leadTimeErrors () {
      const errors = []
      if (!this.$v.leadTime.$dirty) return errors
      !this.$v.leadTime.maxLength && errors.push('Lead time must be less than 500 characters')
      return errors
    }
  },
  validations: {
    name: { required, maxLength: maxLength(200) },
    email: { maxLength: maxLength(500) },
    leadTime: { maxLength: maxLength(500) }
  },
  methods: {
    new () {
      // 5
      this.$v.$reset()
      this.id = null
      this.name = ''
      this.email = ''
      this.leadTime = 0
      this.dialog = true
    },
    edit (item) {
      // 5
      this.$v.$reset()
      this.id = item.id
      this.name = item.name
      this.email = item.email
      this.leadTime = item.lead_time
      this.dialog = true
    },
    confirm () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('Invalid')
      } else {
        if (this.id !== null) {
          this.updateItem()
        } else {
          this.createItem()
        }
      }
    },
    createItem () {
      this.loading = true
      this.error = ''
      this.$axios.post('suppliers/create',
        {
          name: this.name,
          email: this.email,
          leadTime: this.leadTime
        },
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.dialog = false
          })
        .catch(
          (error) => {
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.loading = false
        })
        // */
    },
    updateItem () {
      this.loading = true
      this.error = ''
      this.$axios.patch('suppliers',
        {
          id: this.id,
          name: this.name,
          email: this.email,
          leadTime: this.leadTime
        },
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.dialog = false
          })
        .catch(
          (error) => {
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.loading = false
          this.$emit('onSupplierUpdated')
        })
        // */
    }
  }
}
</script>

<style scoped>

</style>
